import * as React from 'react';
import Container from '@mui/material/Container';
import { Navigate, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';
import "../App.css"
import ReportIcon from '@mui/icons-material/Report';

import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

import CustomSnackbar from '../components/CustomSnackbar';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';

import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import Slide from '@mui/material/Slide';

import Input from '@mui/material/Input';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import Resizer from 'react-image-file-resizer';
import ClearIcon from '@mui/icons-material/Clear';

import AppConfig from '../services/app-config';
import VerificationInput from "react-verification-input";

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { useRef } from 'react';
import Fab from '@mui/material/Fab';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import PeopleIcon from '@mui/icons-material/People';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import HotelIcon from '@mui/icons-material/Hotel';
import ContactsIcon from '@mui/icons-material/Contacts';
import AuthService from '../services/auth';
import { alpha } from '@mui/material/styles';
import wsClient from '../services/ws';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import BannerNotificationsStack from '../components/BannerNotificationsStack';

import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import HistoryIcon from '@mui/icons-material/History';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Join({setNavbarState, navbarState}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' })
  const [loadingPreview, setLoadingPreview] = React.useState(true)
  const [loadinQuery, setLoadingQuery] = React.useState(true)
  const [visitas, setVisitas] = React.useState('')
  const [code, setCode] = React.useState('')
  const [dialogIsOpen, setDialogIsOpen] = React.useState(false)
  const [successDialog, setSuccessDialog] = React.useState(false)
  const [plates, setPlates] = React.useState("")
  const [dialogSearchIsOpen, setDialogSearchIsOpen] = React.useState(false)
  const [isInvalid, setIsInvalid] = React.useState(false)
  const [dialogData, setDialogData] = React.useState(null)
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [image, setImage] = React.useState(null);
  const [data, setData] = React.useState([]); // New state variable for received data
  const [search, setSearch] = React.useState(''); // New state variable for search
  const [idReminder, setIdReminder] = React.useState({ open: false, message: '', code: '', visitor: '' });
  const [duplicateDialog, setDuplicateDialog] = React.useState({ open: false });
  const apiUrl = process.env.REACT_APP_MGO_API_URL;
  const navigate = useNavigate();
  let redirectCurious = false;
  const [org, setOrg] = React.useState("");
  const [weather, setWeather] = React.useState({ temp: "", icon: 'NONE', fetched: false });
  const [bannerNotifications, setBannerNotifications] = React.useState([]);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  
  // WebSocket client for real-time updates handled globally; subscribe here

  var scannedCode = new URLSearchParams(location.search).get('codigo');
  var checkinCoordination = {code_submitted: false, image_submitted: false}
  if (scannedCode !== null) {
    scannedCode = scannedCode.toUpperCase();
    redirectCurious = true;
  }
  const qrState = new URLSearchParams(location.search).get('qr');

  
  const fabStyle = {
    position: 'fixed',
    bottom: 96,
    right: 24,
    width: 56,
    height: 56,
    borderRadius: 3,
    boxShadow: '0 12px 28px rgba(2,21,69,0.22)'
  };

  const handleCodeInput = (e) => {
    const strcode = e.toUpperCase()
    setCode(strcode)
    if (strcode.length === 6) {
      handleVerificarPress(strcode)
    }
  }

  function titleCase(str) {
    return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  // Helper function to compute a simple hash of a file
  const computeFileHash = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        // Simple hash: combine file size, name, and first/last bytes
        let hash = file.size.toString() + file.name + file.lastModified;
        if (uint8Array.length > 0) {
          hash += uint8Array[0] + uint8Array[Math.floor(uint8Array.length / 2)] + uint8Array[uint8Array.length - 1];
        }
        resolve(hash);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };

  // Get the rolling array of hashes from localStorage
  const getImageHashes = () => {
    try {
      const hashes = localStorage.getItem('recentImageHashes');
      return hashes ? JSON.parse(hashes) : [];
    } catch (error) {
      console.error('Error reading image hashes from localStorage:', error);
      return [];
    }
  };

  // Add a new hash to the rolling array (keep only last 10)
  const addImageHash = (hash) => {
    try {
      let hashes = getImageHashes();
      // Add the new hash at the beginning
      hashes.unshift(hash);
      // Keep only the last 10
      if (hashes.length > 10) {
        hashes = hashes.slice(0, 10);
      }
      localStorage.setItem('recentImageHashes', JSON.stringify(hashes));
    } catch (error) {
      console.error('Error saving image hash to localStorage:', error);
    }
  };

  // Check if hash already exists in the array
  const isHashDuplicate = (hash) => {
    const hashes = getImageHashes();
    return hashes.includes(hash);
  };

  const handleIdImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // Compute hash of the file
      const fileHash = await computeFileHash(file);
      
      // Check if this hash already exists in recent uploads
      if (isHashDuplicate(fileHash)) {
        // Open dialog warning (different content for desktop vs mobile)
        setDuplicateDialog({ open: true });
        // Clear the file input
        e.target.value = '';
        return;
      }

      // Process the image
      if (file.size > 1024 * 1024) {
          Resizer.imageFileResizer(
              file,
              800, // Max width
              800, // Max height
              'JPEG', // Output format
              80, // Quality
              0, // Rotation
              (compressedFile) => {
                  setImage(compressedFile);
              },
              'blob' // Output type
          );
      } else {
          setImage(file);
      }
    } catch (error) {
      console.error('Error processing image:', error);
      // If there's an error with hash computation, still allow the image to be set
      if (file.size > 1024 * 1024) {
          Resizer.imageFileResizer(
              file,
              800, // Max width
              800, // Max height
              'JPEG', // Output format
              80, // Quality
              0, // Rotation
              (compressedFile) => {
                  setImage(compressedFile);
              },
              'blob' // Output type
          );
      } else {
          setImage(file);
      }
    }
  }

  const handleVehiclePlateChange = (event) => {
    setPlates(event.target.value.toUpperCase());
  };
  
  const handleVerificarPress = (autoinput_code="null") => {
    let data;
    if (typeof autoinput_code === 'string' || autoinput_code instanceof String) {
      data = { "code": autoinput_code }
      setCode(autoinput_code)
    } else  {
      data = { "code": code }
    }
    if (data.code.length !== 6) {
      setSnackbar({ open: true, message: 'El codigo debe tener 6 digitos.', severity: 'warning' })
      return
    }
    setLoadingQuery(true)
    setDialogIsOpen(true)
    setDialogSearchIsOpen(false)
    setIsInvalid(false)
    apiClient.post('visit/query', data, {}, { action: 'query_visit' })
      .then(response => {
        if (response.status === 200) {
          setDialogData(response.data.data);
          console.log(response.data.data)
          if (response.data.data.type && response.data.data.type === "airbnb") {
            navigate(`/airbnb/reservacion/${response.data.data.airbnb_reservation}`) 
          }
          if (response.data.data.vehicle_plate) {
            setPlates(response.data.data.vehicle_plate)
          }
          setDialogIsOpen(true)
          setLoadingQuery(false)
        } 
        else if (response.status === 423) {
          // Code has already been used and doesn't allow multiple entries
          const errorMsg = response.data?.msg || 'El código ya ha sido utilizado y no permite re-ingreso.';
          setSnackbar({ open: true, message: errorMsg, severity: 'warning' });
          setDialogIsOpen(false);
          setLoadingQuery(false);
          setCode('');
        }
        else if (response.status === 401 && redirectCurious) {
          window.location.href = 'https://migarita.online'
        }
        else {
          console.error("Error verifying code: ", response.status);
          setDialogIsOpen(false)
          setLoadingQuery(false)
        }
      })
      .catch(error => {
        if (error?.response?.status === 423) {
          const errorMsg = error?.response?.data?.msg || 'El código ya ha sido utilizado y no permite re-ingreso.';
          setSnackbar({ open: true, message: errorMsg, severity: 'warning' });
          setCode('');
        } else {
          setIsInvalid(true);
        }
        setLoadingQuery(false);
      })
  }

  const handleSearchPress = () => {
    setLoadingQuery(true)
    apiClient.get('visits/all', {}, { action: 'fetch_all_visits' })
      .then(response => {
        if (response.status === 200) {
          setData(response.data.data);
          setVisitas(response.data.data.active.length)
          setDialogSearchIsOpen(true)
          setLoadingQuery(false)
        } else {
          console.error("Error verifying code: ", response.status);
          setDialogIsOpen(false)
          setLoadingQuery(false)
        }
      })
      .catch(error => {
        if (error?.response?.status === 423) {
          const errorMsg = error?.response?.data?.msg || 'El acceso ha sido bloqueado o ya fue utilizado.';
          setSnackbar({ open: true, message: errorMsg, severity: 'warning' });
        } else {
          setIsInvalid(true);
        }
        setLoadingQuery(false);
      })
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  }
  React.useEffect(() => {
    setNavbarState({ showSearch: false, showOptions: false, showBack: true});
    if (dialogSearchIsOpen) {
      setLoadingQuery(true)
      apiClient.get('visits/all', {}, { action: 'fetch_all_visits' })
        .then(response => {
          if (response.status === 200) {
            setData(response.data.data)
            setLoadingQuery(false)
          } else {
            console.error("Error querying data: ", response.status);
            setLoadingQuery(false)
          }
        })
        .catch(error => {
          if (error?.response?.status === 423) {
            const errorMsg = error?.response?.data?.msg || 'El acceso ha sido bloqueado o ya fue utilizado.';
            setSnackbar({ open: true, message: errorMsg, severity: 'warning' });
          } else {
            console.error("Error querying data: ", error);
          }
          setLoadingQuery(false);
        })
    }
  }, [dialogSearchIsOpen]);

  const renderData = (state) => {
    // First filter the data
    const filteredData = data[state].filter(item => 
      item.code.toLowerCase().includes(search.toLowerCase()) || 
      item.visit_name.toLowerCase().includes(search.toLowerCase()) || 
      item.unit.toLowerCase().includes(search.toLowerCase())
    );
    // Render the filtered data
    return filteredData.map(item => (
      <Grid item xs={12} sm={6} md={4} key={item.code}>
        <Card style={{ borderRadius: '10px' }}>
          <CardContent>
            <Typography variant="h5">{item.code}</Typography>
            <Box display="flex" alignItems="center">
              {item.type && item.type === 'airbnb' && <img src="/airbnb-logo.png" alt="Airbnb Logo" style={{ width: '30px', height: '30px', marginRight: '10px' }} />}
              <Typography variant="h6">{item.visit_name}</Typography>
            </Box>
            <Typography color="text.secondary">{AppConfig.get('unit_type')} {item.unit}</Typography>
            <Typography color="text.secondary">Creado {AppConfig.formatFriendlyDate(item.ts)}</Typography>
            <Typography color="text.secondary">{item.ts_used ? `Usado ${AppConfig.formatFriendlyDate(item.ts_used)}`: ''}</Typography>
          </CardContent>
          <CardActions>
            <Button onClick={() => handleVerificarPress(item.code)} size="small" color="primary">
                Abrir
            </Button>
          </CardActions>
        </Card>
      </Grid>
    ));
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const closeDialog = () => {
    setDialogIsOpen(false);
    setDialogData(null);
    setImage(null);
  };

  const generateEpochTimestamp = () => {
    return Math.floor(Date.now() / 1000);
  };

  const closeSearchDialog = () => {
    setDialogSearchIsOpen(false);
  };

  const closeSuccessDialog = () => {
    setSuccessDialog(false);
  };

  const handleIdReminderClose = () => {
    setIdReminder({ open: false, message: '', code: '', visitor: '' });
  };

  const widgetSizes = {
    directorio: AppConfig.haveModule('issues') ? 6 : 12,
    airbnb: 12,
  }

  const handleClick = (route) => {
    setRedirect({ trigger: true, route: `/${route.toLowerCase()}` })
  }

  const navigateToBannerUrl = React.useCallback((url) => {
    if (!url) {
      return;
    }

    const trimmed = url.trim();

    if (!trimmed) {
      return;
    }

    const isAbsolute = /^https?:\/\//i.test(trimmed);

    if (isAbsolute) {
      window.open(trimmed, '_blank', 'noopener,noreferrer');
      return;
    }

    const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    setRedirect({ trigger: true, route: normalized });
  }, [setRedirect]);


  const syncRequests = () => {
    if (!AppConfig.getLocal("require_id_image")) {
      checkinCoordination.image_submitted = true
    }
    if (checkinCoordination.code_submitted && checkinCoordination.image_submitted) {
      setDialogIsOpen(false);
      setDialogSearchIsOpen(false);
      closeDialog();
      fetchVisitsData();
      setLoadingQuery(false);
      setSuccessDialog(true)
      setCode('')
      setTimeout(function() {
        closeSuccessDialog();
      }, 1800);
    }  
  }

  const uploadId = (image_id) => {
    const formData = new FormData();
    formData.append('image_id', image_id);
    if (image) {
        formData.append('image', image);
    }
    return apiClient.post('visit/id/upload', formData, {}, { action: 'upload_visit_id' })
        .then((response) => {
            if (response.status === 200) {
                checkinCoordination.image_submitted = true
                syncRequests()
              }
            return response;
        })
        .catch((error) => {
            setLoadingQuery(false);
            if(error.response && error.response.status === 400) {
                setSnackbar({ open: true, message: 'La imagen no es una identificación válida. Por favor, tome una foto clara del DPI o Licencia.', severity: 'error' });
            }
            else if(error.response && error.response.data && error.response.data.code === 422) {
                setSnackbar({ open: true, message: error.response.data.data.mensaje, severity: 'error' });
            }
            else  {
                console.error('Error commenting:', error);
                setSnackbar({ open: true, message: "Hubo un error al intentar subir la imagen de la identificacion", severity: 'error' });
            }
            // Re-throw so callers (expireCode) can decide whether to proceed
            throw error;
        });
  };

  const expireCode = async () => {
    var image_id = false;
    checkinCoordination = {code_submitted: false, image_submitted: false}
    if (AppConfig.getLocal("require_id_image") && !image) {
      setSnackbar({ open: true, message: 'Es necesario tomar una foto de la identificacion. (DPI o Licencia)', severity: 'warning' })
      return
    }
    
    if (AppConfig.getLocal("require_id_image")) {
      image_id = `${code}-${generateEpochTimestamp()}`;
      // Start loading while uploading the ID image
      setLoadingQuery(true)
      try {
        await uploadId(image_id);
      } catch (error) {
        // If backend rejects with 400 (invalid ID), do not proceed with check-in
        if (error?.response?.status === 400) {
          // Loading state handled in uploadId catch, ensure no further processing
          return;
        }
        // For other errors during upload, stop as well to avoid inconsistent state
        return;
      }
    }

    setLoadingQuery(true)
    apiClient.post('visit/checkin', {"access_code": code, "plates": plates, "image_id": image_id}, {}, { action: 'checkin_visit' })
      .then(response => {
        if (response.status === 200) {
          checkinCoordination.code_submitted = true
          // After full confirm flow success, store the image hash if present
          if (image) {
            computeFileHash(image)
              .then((hash) => {
                addImageHash(hash);
              })
              .catch((err) => console.error('Error computing hash after check-in:', err));
          }
          syncRequests()
        } else {
          console.error("Error verifying code: ", response.status);
          setDialogIsOpen(false)
          setLoadingQuery(false)
        }
      })
      .catch(error => {
        if (error.response.data.code === 423) {
          setDialogIsOpen(false)
          setDialogSearchIsOpen(false)
          setSnackbar({ open: true, message: 'El codigo ya ha sido utlizado, no es permitido re-ingresar con este mismo codigo.', severity: 'warning' })
        }
        setIsInvalid(false)
        setLoadingQuery(false)
        setCode('')
      })
  };

  const fileInputRef = useRef(null);

  const handleUploadImage = () => {
    fileInputRef.current.click();
  };


  const fetchVisitsData = () => {
    apiClient.get('visits/number', {}, { action: 'fetch_visits_number' })
      .then((response) => {
        if (response.status === 200) {
          setVisitas(response.data.data.Visits);
          setBannerNotifications(response.data?.data?.banner_notifications || []);
          setLoadingPreview(false)
        } 
      })
      .catch((error) => {
        console.error("Error fetching data: ", error?.response?.data?.code);
        if (shouldRedirectToLogin(error)) {
          setRedirect({ trigger: true, route: '/login' })
        }
      })
  }

  const getWeather = async () => {
    try {
      const response = await apiClient.get('weather/current', {}, { action: 'fetch_weather' });
      setWeather({ temp: response.data.data.temp, icon: response.data.data.icon, fetched: true });
    } catch (error) {
      console.error(error);
    }
  };

  // Modify the existing useEffect
  React.useEffect(() => {
    setNavbarState({ showSearch: false, showOptions: false, showBack: true});
    setOrg(AuthService.getCurrentUserOrg());
    if (AuthService.shouldLimitAutomatedAgentRequests()) {
      return undefined;
    }
    getWeather();
    fetchVisitsData();
    if (scannedCode) {
      setCode(scannedCode)
      if (qrState === "1") {
        handleVerificarPress(scannedCode)
      }
      setRedirect({ trigger: true, route: `/recepcion` });
    }

    // Set up interval to refresh weather every 30 minutes
    const weatherInterval = setInterval(() => {
      getWeather();
    }, 30 * 60 * 1000); // 30 minutes in milliseconds

    // Clean up function to clear the interval when component unmounts
    return () => clearInterval(weatherInterval);
  }, [])

  // Subscribe to expected visits updates via WebSocket
  React.useEffect(() => {
    // Listen for expected_visits count updates
    const offExpectedVisits = wsClient.on('expected_visits', (msg) => {
      console.log('[Reception] Received expected_visits event:', msg);
      // Expecting payload: { type: 'expected_visits', data: { count: number } }
      const count = msg?.data?.count;
      if (typeof count === 'number') {
        console.log('[Reception] Updating visits count to:', count);
        setVisitas(count);
        setLoadingPreview(false);
      } else {
        console.warn('[Reception] Invalid count in expected_visits:', msg);
      }
    });

    // Listen for new_code events (refresh count when new codes are created)
    const offNewCode = wsClient.on('new_code', (msg) => {
      console.log('[Reception] Received new_code event:', msg);
      // When a new code is created, refresh the count
      fetchVisitsData();
    });

    const offIdVerificationFailed = wsClient.on('id_verification_failed', (msg) => {
      console.log('[Reception] Received id_verification_failed event:', msg);
      const visitorName = msg?.data?.visitor_name || msg?.data?.name || '';
      const code = msg?.data?.code || '';
      const friendlyMessage = 'La verificación de la identificación no fue exitosa. Por favor, recuerda tomar la foto del DPI o licencia asegurándote de que el nombre completo sea legible y sin reflejos.';
      setIdReminder({
        open: true,
        message: friendlyMessage,
        code,
        visitor: visitorName,
      });
    });

    return () => {
      if (typeof offExpectedVisits === 'function') offExpectedVisits();
      if (typeof offNewCode === 'function') offNewCode();
      if (typeof offIdVerificationFailed === 'function') offIdVerificationFailed();
    };
  }, []);

  const markBannerAction = React.useCallback(async (notificationId, action) => {
    if (!notificationId) {
      return;
    }
    try {
      await apiClient.post('banner_notifications/action', {
        notification_id: notificationId,
        action,
      }, {}, { action: `reception_banner_${action}` });
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleDismissBanner = React.useCallback((notificationId) => {
    if (!notificationId) {
      return;
    }
    setBannerNotifications((prev) => prev.filter((banner) => banner.id !== notificationId));
    markBannerAction(notificationId, 'dismiss');
  }, [markBannerAction]);

  const handleViewBanner = React.useCallback((notificationId) => {
    markBannerAction(notificationId, 'view');
  }, [markBannerAction]);

  const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: (theme) => theme.shadows[6],
    },
  };

  const cardStyleNoHover = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };

  const iconStyle = {
    position: 'absolute',
    right: -20,
    bottom: -20,
    fontSize: 105,
    color: 'rgba(0, 0, 0, 0.10)',
  };

  const getWeatherShortLabel = React.useCallback((icon) => {
    switch (String(icon || '').toUpperCase()) {
      case 'CLEAR_DAY':
        return 'Soleado';
      case 'PARTLY_CLOUDY_DAY':
        return 'Parcial';
      case 'CLOUDY':
        return 'Nublado';
      case 'RAIN':
        return 'Lluvia';
      case 'SLEET':
        return 'Aguanieve';
      case 'SNOW':
        return 'Nieve';
      case 'FOG':
        return 'Niebla';
      case 'CLEAR_NIGHT':
        return 'Despejado';
      case 'PARTLY_CLOUDY_NIGHT':
        return 'Parcial';
      default:
        return 'Clima';
    }
  }, []);

  const todayLabel = React.useMemo(() => {
    try {
      const d = new Date();
      const formatted = d
        .toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace('.', '');
      return formatted;
    } catch (e) {
      return '';
    }
  }, []);

  return (
    <Container maxWidth="sm" disableGutters>
        {redirect.trigger && (
            <Navigate to={redirect.route} replace={true} />
        )}
        <Box sx={{ ml: 0 }} maxWidth={true} display="flex" alignItems="center">
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadingPreview}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <CustomSnackbar 
              open={snackbar.open}
              message={snackbar.message}
              severity={snackbar.severity}
              onClose={() => setSnackbar({ ...snackbar, open: false })}
            />
            {!loadingPreview &&
                (<Box maxWidth={true} display="flex" alignItems="center" flexDirection="column" sx={{ pt: 0, pb: 10 }}>
                    <Box
                      sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        width: '100%',
                        px: 3,
                        pt: 3,
                        pb: 2,
                        backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.95),
                        backdropFilter: 'blur(10px)',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75 }}>
                          <Box
                            component="img"
                            src={`/orgs/${String(org || '').toLowerCase()}.png`}
                            alt={`${org}-logo`}
                            sx={{
                              width: 48,
                              height: 48,
                              borderRadius: '10px',
                              objectFit: 'contain',
                              backgroundColor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              p: 0.5,
                            }}
                          />
                          <Box>
                            <Typography sx={{ fontSize: 10, fontWeight: 800, opacity: 0.65, letterSpacing: 1, textTransform: 'uppercase' }}>
                              Hola, {String(AuthService.getCurrentUser() || '').toUpperCase()}
                            </Typography>
                            <Typography sx={{ fontSize: 22, fontWeight: 900, lineHeight: 1.1, letterSpacing: -0.5, color: 'text.primary' }}>
                              Recepción
                            </Typography>
                          </Box>
                        </Box>

                        <IconButton
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '10px',
                            border: '1px solid',
                            borderColor: 'divider',
                            color: 'text.primary',
                          }}
                          onClick={() => handleClick('perfil')}
                        >
                          <PersonIcon />
                        </IconButton>
                      </Box>

                      <Stack direction="row" spacing={1.25} sx={{ overflowX: 'auto', pb: 0.5 }}>
                        <Chip
                          variant="outlined"
                          icon={weather.fetched ? <WbSunnyOutlinedIcon /> : <CircularProgress size={16} />}
                          label={weather.fetched ? `${getWeatherShortLabel(weather.icon)} ${weather.temp}°C` : 'Cargando clima'}
                          sx={{
                            borderRadius: '10px',
                            borderColor: 'divider',
                            color: 'text.primary',
                            height: 36,
                            flexShrink: 0,
                            backgroundColor: 'background.paper',
                            '& .MuiChip-icon': { color: 'text.primary' },
                            '& .MuiChip-label': { fontWeight: 700, fontSize: 12 },
                          }}
                        />
                        <Chip
                          variant="outlined"
                          icon={<LocationOnOutlinedIcon />}
                          label={org || '—'}
                          sx={{
                            borderRadius: '10px',
                            borderColor: 'divider',
                            color: 'text.primary',
                            height: 36,
                            flexShrink: 0,
                            backgroundColor: 'background.paper',
                            '& .MuiChip-icon': { color: 'text.primary' },
                            '& .MuiChip-label': { fontWeight: 700, fontSize: 12 },
                          }}
                        />
                        <Chip
                          variant="outlined"
                          icon={<CalendarTodayOutlinedIcon />}
                          label={todayLabel || '—'}
                          sx={{
                            borderRadius: '10px',
                            borderColor: 'divider',
                            color: 'text.primary',
                            height: 36,
                            flexShrink: 0,
                            backgroundColor: 'background.paper',
                            '& .MuiChip-icon': { color: 'text.primary' },
                            '& .MuiChip-label': { fontWeight: 700, fontSize: 12 },
                          }}
                        />
                      </Stack>
                    </Box>

                    <Box sx={{ width: '100%', px: 2, mt: 2 }}>
                      <BannerNotificationsStack
                        banners={bannerNotifications}
                        onNavigate={navigateToBannerUrl}
                        onView={handleViewBanner}
                        onDismiss={handleDismissBanner}
                      />
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                        <Typography sx={{ fontSize: 18, fontWeight: 800, color: 'text.primary' }}>Métricas Clave</Typography>
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: '#ef4444',
                            '@keyframes pulse': {
                              '0%': { transform: 'scale(1)', opacity: 1 },
                              '70%': { transform: 'scale(1.6)', opacity: 0.35 },
                              '100%': { transform: 'scale(1)', opacity: 1 },
                            },
                            animation: 'pulse 1.6s infinite',
                          }}
                        />
                      </Box>

                      <Card
                        sx={{
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: (theme) => theme.shadows[2],
                          overflow: 'hidden',
                        }}
                      >
                        <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'text.secondary', mb: 0.5 }}>
                              Actividad de hoy
                            </Typography>
                            <Typography sx={{ fontSize: 34, fontWeight: 900, color: 'text.primary', lineHeight: 1.1 }}>
                              {visitas} Visitas
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.75, color: 'secondary.main' }}>
                              <DoneOutlineIcon sx={{ fontSize: 16 }} />
                              <Typography sx={{ fontSize: 13, fontWeight: 700 }}>Esperadas para hoy</Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              width: 56,
                              height: 56,
                              borderRadius: 3,
                              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'primary.main',
                            }}
                          >
                            <PeopleIcon sx={{ fontSize: 32 }} />
                          </Box>
                        </CardContent>
                      </Card>
                    </Box>

                    <Box sx={{ width: '100%', px: 2, mt: 3 }}>
                      <Typography sx={{ fontSize: 18, fontWeight: 800, color: 'text.primary', mb: 1.5 }}>
                        Validar Acceso
                      </Typography>
                      <Card
                        sx={{
                          borderRadius: 3,
                          bgcolor: 'background.paper',
                          border: '1px solid',
                          borderColor: 'divider',
                          boxShadow: (theme) => theme.shadows[2],
                        }}
                      >
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary', textAlign: 'center', mb: 2 }}
                          >
                            Introduce el código de 6 dígitos
                          </Typography>
                          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <VerificationInput
                              classNames={{
                                character: 'character',
                                characterInactive: 'character--inactive',
                                characterSelected: 'character--selected',
                              }}
                              placeholder=""
                              value={code}
                              onChange={handleCodeInput}
                              autoFocus={false}
                            />
                          </Box>
                          <Button
                            variant="contained"
                            sx={{
                              mt: 0.5,
                              py: 1.5,
                              borderRadius: 2,
                              bgcolor: 'primary.main',
                              '&:hover': { bgcolor: 'primary.dark' },
                            }}
                            size="large"
                            onClick={handleVerificarPress}
                            fullWidth
                          >
                            Verificar Código
                          </Button>
                        </CardContent>
                      </Card>
                    </Box>

                    <Box sx={{ width: '100%', px: 2, mt: 3 }}>
                      <Typography sx={{ fontSize: 18, fontWeight: 800, color: 'text.primary', mb: 1.5 }}>
                        Acciones Rápidas
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Card
                            sx={{
                              borderRadius: 3,
                              bgcolor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: (theme) => theme.shadows[1],
                              cursor: 'pointer',
                            }}
                            onClick={handleSearchPress}
                          >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 3 }}>
                              <Box
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: 2.5,
                                  bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
                                  color: 'secondary.main',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <EmojiPeopleIcon sx={{ fontSize: 28 }} />
                              </Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 800, textAlign: 'center', color: 'text.primary' }}>Buscar Visitante</Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={6} sx={{ display: AppConfig.haveModule('visits') ? 'block' : 'none' }}>
                          <Card
                            sx={{
                              borderRadius: 3,
                              bgcolor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: (theme) => theme.shadows[1],
                              cursor: 'pointer',
                            }}
                            onClick={(event) => handleClick('directorio')}
                          >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 3 }}>
                              <Box
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: 2.5,
                                  bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
                                  color: 'secondary.main',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <ContactsIcon sx={{ fontSize: 28 }} />
                              </Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 800, textAlign: 'center', color: 'text.primary' }}>Directorio</Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={6} sx={{ display: AppConfig.haveModule('visits') ? 'block' : 'none' }}>
                          <Card
                            sx={{
                              borderRadius: 3,
                              bgcolor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: (theme) => theme.shadows[1],
                              cursor: 'pointer',
                            }}
                            onClick={() => handleClick('visitas/manual')}
                          >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 3 }}>
                              <Box
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: 2.5,
                                  bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
                                  color: 'secondary.main',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <PersonAddAltOutlinedIcon sx={{ fontSize: 28 }} />
                              </Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 800, textAlign: 'center', color: 'text.primary' }}>Registro Manual</Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={6}>
                          <Card
                            sx={{
                              borderRadius: 3,
                              bgcolor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: (theme) => theme.shadows[1],
                              cursor: 'pointer',
                            }}
                            onClick={() => handleClick('actividad')}
                          >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 3 }}>
                              <Box
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: 2.5,
                                  bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
                                  color: 'secondary.main',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <HistoryIcon sx={{ fontSize: 28 }} />
                              </Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 800, textAlign: 'center', color: 'text.primary' }}>Actividad</Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={6} sx={{ display: AppConfig.haveModule('issues') ? 'block' : 'none' }}>
                          <Card
                            sx={{
                              borderRadius: 3,
                              bgcolor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: (theme) => theme.shadows[1],
                              cursor: 'pointer',
                            }}
                            onClick={(event) => handleClick('reportes')}
                          >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 3 }}>
                              <Box
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: 2.5,
                                  bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
                                  color: 'secondary.main',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <ReportIcon sx={{ fontSize: 28 }} />
                              </Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 800, textAlign: 'center', color: 'text.primary' }}>Reportar Avería</Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={6} sx={{ display: AppConfig.haveModule('airbnb') ? 'block' : 'none' }}>
                          <Card
                            sx={{
                              borderRadius: 3,
                              bgcolor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: (theme) => theme.shadows[1],
                              cursor: 'pointer',
                            }}
                            onClick={(event) => handleClick('airbnb')}
                          >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 3 }}>
                              <Box
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: 2.5,
                                  bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
                                  color: 'secondary.main',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <HotelIcon sx={{ fontSize: 28 }} />
                              </Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 800, textAlign: 'center', color: 'text.primary' }}>Airbnb</Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Box>
                </Box>)}
            <Dialog open={dialogIsOpen} onClose={closeDialog}>
              <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={loadinQuery}
              >
                  <CircularProgress color="inherit" />
            </Backdrop>
              {!loadinQuery &&
                (<><DialogTitle variant='h5' sx={{ textAlign: 'center', mb: 0, mt: 3.8 }} id="dialog-title">{isInvalid ? 'Codigo Invalido' : 'Informacion del Visitante'}</DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={closeDialog}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent sx={{ px: 4}}>
                    <Typography sx={{ mt: 0, mb: 0}} variant='h6'>{dialogData ? dialogData.visitor_name : ''}</Typography>
                    <Typography sx={{ mb: 0}} variant='body1'>{dialogData ? `${AppConfig.get('unit_type')} ${dialogData.unit}` : ''}</Typography>
                    <Typography style={{fontSize: 15}} display="inline" variant='h6'>{dialogData ? dialogData.vehicle && <TextField fullWidth size="small" type='text' id='plate' sx={{ mt:3,mb: 0.5, ml: -0.5, pr: "50%" }} label="Placa" value={plates} onChange={handleVehiclePlateChange} variant="outlined" disabled={dialogData && dialogData.status == "vencido"}/> : ""}</Typography>
                    <Typography>{dialogData ? dialogData.vehicle ? 'Acceso Vehicular' : '' : ''}</Typography>
                    <Typography>{dialogData ? dialogData.walking ? 'Acceso Peatonal' : '' : ''}</Typography>
                    {dialogData && dialogData.notes && (
                      <Box sx={{ mt: 1.5, p: 1.5, borderRadius: 2, bgcolor: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.3)' }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.secondary', mb: 0.5 }}>Notas del Residente:</Typography>
                        <Typography variant="body2">{dialogData.notes}</Typography>
                      </Box>
                    )}
                    {isInvalid &&
                      <Box sx={{ textAlign: "center"}}>
                        <NoEncryptionGmailerrorredIcon color="error" fontSize="large"/>
                      </Box>
                    }
                     {AppConfig.getLocal("require_id_image") && !isInvalid && (
                        <>   
                        {image ? (
                        <>
                        <Box style={{ position: 'relative', marginTop: "8px" }}>
                            <ClearIcon style={{ position: 'absolute', top: '-4px', left: '-8px', cursor: 'pointer' }} onClick={() => setImage(null)} />
                            <img src={URL.createObjectURL(image)} alt="Selected Image" 
                                style={{
                                    maxWidth: '60%',
                                    height: 'auto',
                                    objectFit: 'cover',
                                    borderRadius: '10px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    marginTop: '8px'
                                }}
                            />
                        </Box>
                        </>
                      ):
                      (
                      <>
                      {!isInvalid && dialogData && dialogData.status !== "vencido" && (
                      <label htmlFor="contained-button-file">
                          <Button variant="text" color='secondary' component="span" startIcon={<AddAPhotoIcon />}>
                              Tomar Fotografia de ID
                          </Button>
                          <Input
                              type="file"
                              inputProps={{ accept: 'image/*', capture: 'environment'}}
                              onChange={handleIdImageChange}
                              id="contained-button-file"
                              sx={{ display: 'none' }}
                          />
                      </label>
                      )}
                      </>
                      )}
                      </>
                    )}
                    {!isInvalid && <Divider sx={{ my: 2}} />}
                    <Typography sx={{ mt: 3}}>{!isInvalid ? 'Residente:' : ''} <b>{dialogData ? dialogData.created_by_name : ''}</b></Typography>
                    {!isInvalid  &&
                    <><Box sx={{ mt: 0 }}>
                      <Typography display="inline" variant='body1'>{!isInvalid ? 'Creado ' : ''} {dialogData ? AppConfig.formatFriendlyDate(dialogData.ts) : ''}</Typography><Typography display="inline" sx={{ ml: 1 }} variant='body2'> {dialogData ? dialogData.yesterday ? ' *ayer': '' : ''}</Typography>
                    </Box>
                    </>
                    }
                    {dialogData ? dialogData.log && (<>
                    <Divider sx={{ my: 2}} />
                    <Typography sx={{ mb: 0}} variant='body1'>Usado Anteriormente</Typography>
                    
                    <Timeline position="left">
                    {dialogData ? dialogData.log && dialogData.log.reverse().map((log, index) => (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent color="text.secondary">{AppConfig.formatFriendlyDate(log.ts)}</TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot />
                        {index < dialogData.log.length - 1 && <TimelineConnector />}
                      </TimelineSeparator>
                      <TimelineContent>{titleCase(log.to)}</TimelineContent>
                    </TimelineItem>
                    )): ''}
                    </Timeline>
                    </>
                    ) : ''}

                                      
                </DialogContent>
                <DialogActions sx={{mb: 2}}>
                    <Button variant="outlined" onClick={closeDialog}>Cancelar</Button>
                    {!isInvalid && dialogData && dialogData.status !== "vencido" && (
                      <Button onClick={() => expireCode()} color="secondary" variant="contained">
                        Confirmar Acceso
                      </Button>
                    )}
                    {!isInvalid && dialogData && dialogData.status === "vencido" && (
                      <Button color="secondary" variant="contained" disabled>
                        Confirmar Acceso
                      </Button>
                    )}
                </DialogActions></>)
              }
                
            </Dialog>
            <Dialog fullScreen open={successDialog} onClose={closeSuccessDialog} TransitionComponent={Transition} keepMounted> 
            <IconButton
                  aria-label="close"
                  onClick={closeSuccessDialog}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              <DialogContent sx={{ backgroundColor: 'secondary.main', color: 'secondary.contrastText' }}>
                  <Box maxWidth="sm" display="flex" alignItems="center" justifyContent="center" sx={{ margin: 'auto', mt: 2 }}>
                    <Box sx={{ textAlign: "center", mt: "40vh"}}>
                          <DoneOutlineIcon
                            style={{ 
                              fontSize: 80,
                              color: 'inherit',
                            }}
                          />
                          <Typography variant="h5"
                            style={{ 
                              color: 'inherit'
                            }}
                          >
                            Acceso Otorgado
                          </Typography>
                    </Box>
                  </Box>
              </DialogContent>

            </Dialog>
            {dialogSearchIsOpen ? (<Dialog fullScreen open={dialogSearchIsOpen} onClose={closeSearchDialog}>
              <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={loadinQuery}
              >
                  <CircularProgress color="inherit" />
            </Backdrop>
              {!loadinQuery &&
                (<>
                <IconButton
                  aria-label="close"
                  onClick={closeSearchDialog}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent sx={{ backgroundColor: 'background.default' }}>
                  <Box maxWidth="sm" display="flex" alignItems="center" justifyContent="center" sx={{ margin: 'auto', mt: 2 }}>
                  <TextField 
                    fullWidth 
                    size="medium" 
                    id='search' 
                    sx={{ textAlign: 'center', mb: 0, mt: 2 }} 
                    label="Buscar Visitante" 
                    variant="outlined" 
                    onChange={handleSearchChange}
                    InputProps={{
                        endAdornment: (
                        <InputAdornment position="end">
                            <IconButton>
                            <SearchIcon />
                            </IconButton>
                        </InputAdornment>
                        )
                    }}
                    />
                    
                  </Box>
                  <Box maxWidth="sm" display="flex" alignItems="center" justifyContent="center" sx={{ margin: 'auto', mt: 2 }}>
                    <Grid container spacing={2}>
                        {data.active ? renderData("active") : ''}  
                    </Grid>
                  </Box>
                  {data.used.length > 0 && (
                    <>
                      <Box maxWidth="sm" display="flex" alignItems="center" justifyContent="left" sx={{ margin: 'auto', mt: 2 }}>
                        <Chip label="Usados" variant="outlined" />
                      </Box>
                      <Box maxWidth="sm" display="flex" alignItems="center" justifyContent="center" sx={{ margin: 'auto', mt: 2 }}>
                        <Grid container spacing={2}>
                        {data ? renderData("used") : ''} 
                        </Grid>
                      </Box>
                    </>
                  )}
                  
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={closeSearchDialog}>Cerrar</Button>
                </DialogActions></>)
              }
                
            </Dialog>) : ''}
            <Dialog open={idReminder.open} onClose={handleIdReminderClose}>
              <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningAmberIcon color="warning" />
                Recordatorio de identificación
              </DialogTitle>
              <DialogContent>
                {idReminder.visitor && (
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                    Visitante: {idReminder.visitor}
                  </Typography>
                )}
                {idReminder.code && (
                  <Typography variant="body2" color="text.secondary">
                    Código de acceso: {idReminder.code}
                  </Typography>
                )}
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {idReminder.message}
                </Typography>
                {isDesktop && (
                  <Box sx={{ p: 1, borderRadius: 1, bgcolor: 'warning.50', border: '1px solid', borderColor: 'warning.light', mt: 1 }}>
                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <WarningAmberIcon fontSize="small" color="warning" />
                      Si está en una computadora de escritorio, también puede subir una captura de pantalla de la vista de la cámara donde el DPI o Licencia sea visible y legible.
                    </Typography>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleIdReminderClose} variant="contained" color="secondary">
                  Entendido
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={duplicateDialog.open} onClose={() => setDuplicateDialog({ open: false })}>
              <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningAmberIcon color="warning" />
                Imagen duplicada
              </DialogTitle>
              <DialogContent>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Parece que esta imagen ya fue subida recientemente.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Por favor, tome una nueva fotografía del documento de identificación.
                </Typography>
                {isDesktop && (
                  <Box sx={{ p: 1, borderRadius: 1, bgcolor: 'warning.50', border: '1px solid', borderColor: 'warning.light' }}>
                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <WarningAmberIcon fontSize="small" color="warning" />
                      Si está en una computadora de escritorio, también puede subir una captura de pantalla de la vista de la cámara donde el DPI o Licencia sea visible y legible.
                    </Typography>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDuplicateDialog({ open: false })} variant="contained" color="secondary">
                  Entendido
                </Button>
              </DialogActions>
            </Dialog>
            <Fab color="secondary" aria-label="add" sx={fabStyle} onClick={() => setRedirect({ trigger: true, route: '/qr' })}>
              <QrCodeScannerIcon />
            </Fab>
        </Box>
    </Container>
);
}